<template>
  <!-- 不启用 tooltip -->
  <span v-if="!showTooltip" class="truncated-text" :style="textStyle">
    {{ displayText }}
  </span>

  <!-- 启用 tooltip -->
  <v-tooltip
    v-else
    :bottom="placement === 'bottom'"
    :top="placement === 'top'"
    :left="placement === 'left'"
    :right="placement === 'right'"
  >
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" class="truncated-text" :style="textStyle">
        {{ displayText }}
      </span>
    </template>

    <!-- 修复：分离 v-html 和纯文本，避免冲突 -->
    <div class="tooltip-content" :style="tooltipStyle">
      <span v-if="isHtml" v-html="fullText"></span>
      <template v-else>{{ fullText }}</template>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TruncatedText',
  props: {
    content: {
      type: String,
      default: '', // 文本内容
    },
    maxLength: {
      type: Number,
      default: 10, //最多显示的字符数（不含省略号）	当字段较长时，可设置为 8、15 或 20，根据表格宽度调整
    },
    suffix: {
      type: String,
      default: '...', //截断时追加的字符串(可更改省略号样式)
    },
    showTooltip: {
      type: Boolean,
      default: true, //是否启用悬停展示全部内容
    },
    placement: {
      type: String,
      default: 'bottom',
      validator: (val) => ['bottom', 'top', 'left', 'right'].includes(val), //工具提示弹出位置	可取 'top'、'bottom'、'left'、'right'。当表格行较密集时，可改为 'top' 避免遮挡下方内容
    },
    tooltipMaxWidth: {
      type: String,
      default: '400px', // 调大默认值，更常用 工具提示的最大宽度	内容很长且希望多行显示时，可设 '500px' 或 '600px'；内容较短时可设 '200px' 避免工具提示过宽
    },
    textMaxWidth: {
      type: String,
      default: '200px', //表格单元格中显示文本的最大宽度	如果表格列宽不固定，可设 '100%'；如果列宽固定，可设具体像素值，配合 maxLength 一起控制视觉截断
    },
    isHtml: {
      type: Boolean,
      default: false, //是否将 content 作为 HTML 渲染	如果 content 包含 <br>、<b> 等标签，设为 true 可保留样式。⚠️ 需确保内容可信，防止 XSS 攻击
    },
  },
  computed: {
    displayText() {
      if (!this.content) return ''
      if (this.content.length <= this.maxLength) return this.content
      return this.content.substring(0, this.maxLength) + this.suffix
    },
    fullText() {
      return this.content || ''
    },
    textStyle() {
      return {
        display: 'inline-block',
        'max-width': this.textMaxWidth,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
        'vertical-align': 'middle',
      }
    },
    tooltipStyle() {
      return {
        'white-space': 'normal', // 允许换行
        'word-wrap': 'break-word', // 自动换行
        'word-break': 'break-word',
        'max-width': this.tooltipMaxWidth,
        // 加宽内边距，保持美观
        padding: '6px 10px',
        // 保证块级显示，避免行内压缩
        display: 'block', // 防止压缩
      }
    },
  },
}
</script>

<style scoped>
/* 保留基础样式，也可全局定义 */
.tooltip-content {
  /* 内联样式已覆盖，此处作为后备 */
}
</style>
